import './App.css';
import Home from './Home.js';
import CruiseContactCard from './components/CruiseContactCard'; // adjust path as needed
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import Layout from './components/Layout.js';
import RenderCarRentals from './components/CarRentals.js';
import Footer from './components/Footer.js';
import Header from './components/Header.js';
import RenderCruisePage from './components/Cruise.js';
import RenderFlights from './components/Flights.js';
import PaymentPolicy from './components/PaymentPolicy.js';
import CancellationAndRefundPolicy from './components/PrivacyPolicy.js';
import Mission from './components/Mission.js';
import TermsandConditions from './components/Terms&Conditions.js';
import FaqPage from './components/FAQ.js';
import FlightSearchPage from './components/FlightSearchPage.js';
import FlightResults from './components/FlightResults.js';
import ScrollToTop from './ScrolltoTop.js';
import CheckoutPage from './components/CheckoutPage.js';
import FlightLoadingScreen from './components/FlightLoadingScreen.js';
import Loader from './components/mainloader.js';
import NoFlights from './components/NoFlightsFound.js';
import PaymentForm from './components/PaymentForm.js';
import PaymentSuccess from './components/PaymentSuccess.js';
import PaymentFailure from './components/PaymentFailure.js';
import RedirectToPayment from './components/RedirectToPayment.js';
import VerticalStepperForm from './components/CheckoutForm.js';
import AirlinesList from './components/AirlinesList.js';
import AirlineDetail from './components/AirlineDetail.js';
import TopRoutesList from './components/AirlinesRoutes.js';
import RouteDetails from './components/RouteDetail.js';
import BlogPage from './components/Blogs.js';
import BlogDetails from './components/BlogDetails.js';
import FlightDestinations from './components/FlightsDestination.js';
import FlightDestinationDetails from './components/FlightDestinationDetail.js';
import Ticketpage from './components/usticket.js';

{/* <Route path="/cruise-contact" element={<CruiseContactCard />} /> */}


function App() {
  return (
    
    <BrowserRouter>
    <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            
              <Home />
           
          }
        />
        <Route
          path="/cruises"
          element={
            <Layout>
              <CruiseContactCard />
            </Layout>
          }
        />
        <Route
          path="/carRentals"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
        <RenderCarRentals />
      </div>
      <Footer/>
    </div>
    </div>
            
          }
        />

        <Route
          path="/noflights"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
        <NoFlights />
      </div>
      <Footer/>
    </div>
    </div>
            
          }
        />

        <Route
          path="/formcheck"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
       <VerticalStepperForm />
      </div>
      <Footer/>
    </div>
    </div>
            
          }
        />

        {/* <Route
          path="/flight-destination"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
       <FlightDestinations/>
      </div>
      <Footer/>
    </div>
    </div>
            
          }
        /> */}

        <Route
          path="/cruise"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
        <RenderCruisePage />
      </div>
      <Footer/>
    </div>
    </div>
            
          }
        />

        <Route
          path="/airlines"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
       <AirlinesList />
      </div>
      <Footer/>
    </div>
    </div>
            
          }
        />

        <Route
          path="/airline-routes"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
       <TopRoutesList />
      </div>
      <Footer/>
    </div>
    </div>
            
          }
        />

        {/* <Route
          path="/blogs"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
      <BlogPage/>
      </div>
      <Footer/>
    </div>
    </div>
            
          }
        /> */}

        <Route
          path="/blog/:slug"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
      <BlogDetails/>
      </div>
      <Footer/>
    </div>
    </div>
            
          }
        />

        <Route path="/airline-routes/:routeSlug" element={<div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
       <RouteDetails />
      </div>
      <Footer/>
    </div>
    </div>} />


        <Route path="/airline/:slug" element={<div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
       <AirlineDetail />
      </div>
      <Footer/>
    </div>
    </div>} />

    <Route path="/flights-to/:citySlug" element={<div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
       <FlightDestinationDetails />
      </div>
      <Footer/>
    </div>
    </div>} />

        <Route
          path="/flights"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
        <RenderFlights />
      </div>
      <Footer/>
    </div>
    </div>
            
          }
        />

        <Route
          path="/policy"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
          <CancellationAndRefundPolicy />
      </div>
      <Footer/>
    </div>
    </div>

    
            
          }
        />

          
      <Route
          path="/termsandconditions"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
          <TermsandConditions />
      </div>
      <Footer/>
    </div>
    </div>

    
            
          }
        />

        <Route
          path="/loading"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      
          <Loader/>
    </div>

    
            
          }
        />

        <Route
          path="/faq"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
          <FaqPage />
      </div>
      <Footer/>
    </div>
    </div>

    
            
          }
        />

        

        <Route
          path="/paymentPolicy"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
          <PaymentPolicy />
      </div>
      <Footer/>
    </div>
    </div>
            
          }
        />

          <Route
          path="/mission"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
          <Mission />
      </div>
      <Footer/>
    </div>
    </div>
            
          }
        />

        <Route
          path="/payment"
          element={
      <div className="bg-black">
          <PaymentForm />
      </div>
      
            
          }
        />

        <Route
          path="/ticket-booking"
          element={
      <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
        <Header />
        
          <Ticketpage />
       
      
      </div>
    </div>
          }
        />

        <Route
  path="/checkout"
  element={
    <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
        <Header />
        <div className="centered-section">
          <CheckoutPage />
        </div>
        <Footer />
      </div>
    </div>
  }
/>

        <Route
          path="/flightresults"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
          <FlightResults />
      </div>
      <Footer/>
    </div>
    </div>

    
            
          }
        />

        <Route
          path="/payment-failure"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
          <PaymentFailure />
      </div>
      <Footer/>
    </div>
    </div>

    
            
          }
        />

        <Route
          path="/redirect-to-payment"
          element={

            <div style={{ fontFamily: 'Arial' }}>
      <div className="app-wrapper">
      <Header />
      <div className="centered-section">
          <RedirectToPayment />
      </div>
      <Footer/>
    </div>
    </div>

    
            
          }
        />

        <Route
          path="/payment-success"
          element={
            <div style={{ fontFamily: 'Arial' }}>
            <div className="app-wrapper">
            <Header />
            <div className="centered-section">
                <PaymentSuccess />
            </div>
            <Footer/>
          </div>
          </div>
          }
        />


      </Routes>
    </BrowserRouter>

  );
}

export default App;
